import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';

const api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Scan API
export const scansApi = {
    create: async (data: {
        url: string;
        sessionId?: number;
        device?: string;
        location?: string;
        scanReason?: string;
    }) => {
        const response = await api.post('/scans', data);
        return response.data;
    },

    get: async (id: number) => {
        const response = await api.get(`/scans/${id}`);
        return response.data;
    },

    getReport: async (id: number) => {
        const response = await api.get(`/scans/${id}/report`);
        return response.data;
    },

    getDebugData: async (id: number) => {
        const response = await api.get(`/scans/${id}/debug`);
        return response.data;
    },
};

// Sessions API
export const sessionsApi = {
    list: async () => {
        const response = await api.get('/sessions');
        return response.data;
    },

    get: async (id: number) => {
        const response = await api.get(`/sessions/${id}`);
        return response.data;
    },

    create: async (data: { url: string; name?: string; scanReason?: string }) => {
        const response = await api.post('/sessions', data);
        return response.data;
    },

    update: async (id: number, data: { name: string }) => {
        const response = await api.patch(`/sessions/${id}`, data);
        return response.data;
    },

    delete: async (id: number) => {
        const response = await api.delete(`/sessions/${id}`);
        return response.data;
    },

    getScans: async (id: number) => {
        const response = await api.get(`/sessions/${id}/scans`);
        return response.data;
    },
};

// Health check
export const healthCheck = async () => {
    const response = await api.get('/health');
    return response.data;
};

// URLs API (for autocomplete)
export const urlsApi = {
    getRecent: async (query?: string) => {
        const response = await api.get('/urls/recent', {
            params: query ? { q: query } : undefined
        });
        return response.data;
    },
};

export default api;

